import { Injectable } from '@angular/core';
import type {PlanPackageResult} from '@app/main/modules/plans/api/plan-api.models';

@Injectable({
  providedIn: 'root'
})
export class PlanUtilsService {

  formatPlanPrice(planPackage: PlanPackageResult): {
    mainPrice: string;
    discountPrice?: string;
    discountPercentage?: number;
    isFree: boolean;
  } {
    if (!planPackage.cost) {
      return {
        mainPrice: 'رایگان',
        isFree: true
      };
    }

    const mainPrice = planPackage.discountPercentage
      ? planPackage.discountedCost?.toString() || planPackage.cost.toString()
      : planPackage.cost.toString();

    return {
      mainPrice,
      discountPrice: planPackage.discountPercentage ? planPackage.cost.toString() : undefined,
      discountPercentage: planPackage.discountPercentage,
      isFree: false
    };
  }


  formatPriceRange(planPackage: PlanPackageResult): string | null {
    if (!planPackage.plan.basePriceRange) {
      return null;
    }

    const minPrice = planPackage.plan.basePriceRange[1] / 10;
    const maxPrice = planPackage.plan.basePriceRange[0] / 10;
    return `از ${minPrice} تا ${maxPrice}`;
  }


  formatCreditDisplay(planPackage: PlanPackageResult): string {
    if (!planPackage.credit) {
      return 'ندارد';
    }
    return `${planPackage.credit.creditCount} پیامک`;
  }


  formatLineDisplay(planPackage: PlanPackageResult): string {
    if (!planPackage.line) {
      return 'ندارد';
    }

    if (planPackage.line.numberLength === 0) {
      return 'فعال';
    }

    return `${planPackage.line.numberLength} رقمی`;
  }


  hasDiscount(planPackage: PlanPackageResult): boolean {
    return !!planPackage.discountPercentage && planPackage.discountPercentage > 0;
  }

}
